<template>
  <div class="ColumnModule" :style="customCss">
    <Pic class="logo" :src="module.logo" />
    <!-- <Pic class="logo" src="../../../../../assets/quipment/modules/znShine-logo.png" /> -->
    <div class="moduleBlock">
      <Pic class="module" :src="module.modulePic" />
      <div class="intro">
        <div class="capacity">
          {{ module.capacity }}
        </div>
        <div class="text">
          {{ module.intro }}
        </div>
      </div>
    </div>
    <div class="descriptionBlock">
      <div
        v-for="(paragraph, index) in module.descriptionParagraphs"
        :key="index"
        class="paragraph">
        {{ paragraph }}
      </div>
    </div>
    <div class="technicalBlock">
      <div class="item">
        <Pic
          src="../../../../../assets/quipment/modules/icons/size.svg" />

        <div class="text">
          <div class="label">
            {{ $t('size') }}
          </div>
          <div class="value">
            {{ module.techDetails.size }}
          </div>
        </div>
      </div>
      <div class="item">
        <Pic
          src="../../../../../assets/quipment/modules/icons/bolt.svg" />

        <div class="text">
          <div class="label">
            {{ $t('power') }}
          </div>
          <div class="value">
            {{ module.techDetails.power }}
          </div>
        </div>
      </div>
      <div class="item">
        <Pic
          src="../../../../../assets/quipment/modules/icons/guarantee.svg" />
        <div class="text">
          <div class="label">
            {{ $t('guarantee') }}
          </div>
          <div class="value">
            {{ module.techDetails.guarantee }}
          </div>
        </div>
      </div>
    </div>
    <div class="prosBlock">
      <div v-for="(pro, index) in module.pros" :key="index" class="item">
        <div class="iconContainer">
          <Pic
            :src="pro.icon" />
        </div>
        <div class="text">
          {{ pro.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    module: Object,
  },
  computed: {
    customCss() {
      return {
        '--themeColor': `${this.module.themeColor || 'red'}`,
      }
    },
  },
}
</script>

<style lang="scss">
.ColumnModule {
  font-size: 1rem;
  line-height: 1.5;
  // margin: 2rem 0;
  padding: 0 1rem;
  text-align: center;
  @include sm {
    padding: 0 2rem;
  }
  @include md {
    padding: 0 2rem;
  }
  @include lg {
    padding: 0 4rem;
  }
  @include xl {
    padding: 0 6rem;
  }

  .logo {
    img {
      margin: 3rem 0 6rem;
      width: 60%;
    }
  }

  .moduleBlock {
    background: var(--themeColor);
    border-radius: 25px;
    padding: 2rem;
    position: relative;
    z-index: 6;

    .module {
      img {
        margin-top: -6rem;
        text-align: center;
        width: 90%;
      }
    }

    .intro {
      margin-top: 1rem;
      text-align: left;

      .capacity {
        font-size: 2rem;
        font-weight: $bold;
      }

      .text {
        min-height: 5rem;
        width: 90%;
      }
    }
  }

  .descriptionBlock {
    background: $grey-lighter;
    border-radius: 25px;
    color: $text-color;
    margin-top: -2rem;
    padding: 4rem 2rem 2rem;
    position: relative;
    text-align: left;
    z-index: 5;
    // @include sm {
    //   min-height: 24rem;
    // }
    // @include md {
    //   min-height: 22rem;
    // }
    @include lg {
      min-height: 15rem;
    }
    // @include xl {
    //   min-height: 20rem;
    // }

    .paragraph {
      &:not(:last-child) {
        margin-bottom: 0.5rem;
      }
    }
  }

  .technicalBlock {
    background: $black;
    border-radius: 25px;
    margin-top: -2rem;
    padding: 4rem 2rem 2rem;
    position: relative;
    text-align: left;
    z-index: 4;

    .item {
      display: flex;
      padding: 1rem 0;

      img {
        // display: inline-block;
        max-height: 2.5rem;
        padding: 0 1rem;
        width: 5rem;
      }

      .text {
        display: inline-block;

        .label {
          font-weight: $bold;
          line-height: 1;
        }

        .value {
          font-size: 1rem;
        }
      }
    }
  }

  .prosBlock {
    background: var(--themeColor);
    border-radius: 25px;
    color: $text-color;
    margin-top: -2rem;
    padding: 4rem 2rem 2rem;
    position: relative;
    text-align: left;
    z-index: 3;

    .item {
      color: $white;
      display: flex;
      padding: 1rem 0;

      .iconContainer {
        align-items: center;
        display: flex;

        img {
          // display: inline-block;
          // border: 1px solid $white;
          max-height: 2.5rem;
          padding: 0 1rem;
          width: 4rem;
        }
      }

      .text {
        display: inline-block;
      }
    }
  }
}
</style>
<i18n>
{
  "lt": {
    "title": "Saulės moduliai",
    "guarantee": "Produkto garantija:",
    "power": "Modulio galia:",
    "size": "Modulio matmenys:"
  }
}
</i18n>
